import { AfterViewInit, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AssessmentAnswerInterface, AssessmentQuestionInterface } from 'app/assessment/models';
import { bodyPartMap } from 'app/assessment/questions/discomfort-body-diagram/body-part-map';
// Import CookieService to get Language value (from cookie)
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cz-discomfort-body-diagram',
  templateUrl: './discomfort-body-diagram.component.html',
  styleUrls: ['./discomfort-body-diagram.component.scss'],
})
export class DiscomfortBodyDiagramComponent implements AfterViewInit {
  // variable delaration for Url
  public bodyDiagram: string;
  // Boolean variable declaration
  public isEvaluation:boolean = false;
  @Input() public readonly data: any;
  @Input() public readonly form: FormGroup;
  @Input() public readonly readOnly: boolean;

  // for positioning the clickable dots on the body chart
  public readonly bodyPartMapping: {} = bodyPartMap;

  constructor(private _elRef: ElementRef,
              private _renderer: Renderer2,
              private readonly _cookieService: CookieService,
              private router: Router) {
     // Here checking current url is evaluation, then boolean value is true
    if (this.router.url === '/my-zone/evaluation') {
      this.isEvaluation = true;
    }
  }

  public ngAfterViewInit(): void {
    // Get Language value using cookieServige
    const cultureCookie:string = this._cookieService.get('Culture');
    // Assigned Body discomfort image Url to bodyDiagram variable
    this.bodyDiagram = './assets/images/components/cz-assessment/section-discomfort/img-discomfort-map-'+cultureCookie+'.png';
    this.populateBodyPartHotSpots();
  }

  public storeBodyPart(question: AssessmentQuestionInterface, answer: AssessmentAnswerInterface): void {
    if (this.readOnly) { return; }

    // change class on the svg circle element
    this.changeHotSpot(question.id, answer.id);

    // update the form
    const questionGroupFormGroup: FormGroup = this.form.controls[question.group] as FormGroup;
    questionGroupFormGroup.controls[question.id].setValue(answer);
    questionGroupFormGroup.markAsDirty();
  }

  private populateBodyPartHotSpots(): void {
    const questions: AssessmentQuestionInterface[] = this.data && this.data.questions;

    for (const key in questions) {
      if (!questions.hasOwnProperty(key)) { continue; }
      const answers: AssessmentAnswerInterface[] = questions[key].answers;

      for (const answerKey in answers) {
        if (!answers.hasOwnProperty(answerKey)) { continue; }

        if (!answers[answerKey].isSelected) { continue; }
        // change class on the svg circle element
        this.changeHotSpot(questions[key].id, answers[answerKey].id);
      }
    }
  }

  private changeHotSpot(questionId: number, answerLabel: number): void {
    this._renderer.setAttribute(
      this._elRef.nativeElement.querySelector(`#i-${questionId}`),
      'class',
      `hotspot discomfort-${answerLabel}`,
    );
    // Dynamic R value
    let dynamicR: number;
    if (this.isEvaluation) {
      dynamicR = (answerLabel === 2) ? 6 : (answerLabel === 3) ? 9.5 : (answerLabel === 4) ? 15.5 : 10;
    } else {
      dynamicR = (answerLabel === 2) ? 5.43 : (answerLabel === 3) ? 7.73 : (answerLabel === 4) ? 10.85 : 10;
    }


    this._renderer.setAttribute(
      this._elRef.nativeElement.querySelector(`#i-${questionId}`),
      'r',
      `${dynamicR}`,
    );
  }

}
